<div fxLayout="column" style="height: 100%">
   <div class="k-form-field sam-full-width sam-margin">
      <samweb-searchbar
         fxFlex="1 1 auto"
         [searchValue$]="directorySearchValue$"
         (searchValueChangedDebounced)="searchTextChanged($event)"
      >
      </samweb-searchbar>

      <samweb-phonetic-slider
         *ngIf="isAttendant$ | async"
         class="phonetic-slider sam-margin-right"
         [brickInstanceId]="brickInstanceId"
      ></samweb-phonetic-slider>

      <button
         *ngIf="filterOnSkillOrgAssociationEnabled$ | async"
         kendoButton
         kendoTooltip
         class="sam-toggle-button button-spacing"
         [disabled]="!(filterOnSkillOrgAssociationPossible$ | async)"
         [class.k-state-active]="filterOnSkillOrgAssociationActive$ | async"
         (click)="toggleIncomingCallFilter()"
         title="{{ 'brick.brick_definitions.directory_browser.filters.clear_incoming_call_toggle' | translate }}"
      >
         <fa-icon [icon]="orgFilterIcon" [fixedWidth]="true"></fa-icon>
      </button>
      <button
         *ngIf="filterOnCallingSubscriberEnabled$ | async"
         kendoButton
         kendoTooltip
         class="sam-toggle-button button-spacing"
         [disabled]="!(filterOnCallingSubscriberPossible$ | async)"
         [class.k-state-active]="filterOnCallingSubscriberActive$ | async"
         (click)="toggleCallerFilter()"
         title="{{ 'brick.brick_definitions.directory_browser.filters.clear_caller_toggle' | translate }}"
      >
         <fa-layers [fixedWidth]="true">
            <fa-icon [icon]="callerFilterIcon"></fa-icon>
            <fa-icon [icon]="callerFilterIcon2" transform="shrink-5 left-7 up-5 rotate-45"></fa-icon>
         </fa-layers>
      </button>

      <button
         class="sam-margin-left"
         *ngIf="('DirectoryCreateContact' | isFeatureEnabled$ | async) && (isAttendant$ | async)"
         kendoButton
         kendoTooltip
         (click)="addEntry()"
      >
         <fa-icon [icon]="userAddIcon"></fa-icon>
      </button>

      <button
         *ngIf="
            (('DirectoryUpdateContact' | isFeatureEnabled$ | async) ||
               ('DirectoryDeleteContact' | isFeatureEnabled$ | async)) &&
            (isAttendant$ | async)
         "
         [disabled]="!(isEntrySelected$ | debounceTime: renderBufferTime | async)"
         kendoButton
         kendoTooltip
         (click)="editEntry()"
      >
         <fa-icon [icon]="userEditIcon"></fa-icon>
      </button>
   </div>

   <ng-template #tooltipTemplate let-anchor>
      <span>{{ anchor.nativeElement.innerText }}</span>
   </ng-template>
   <div
      class="sam-full-height sam-auto-overflow"
      [ngClass]="{
         'sam-grid-loading': (directorySearchResult$ | debounceTime: renderBufferTime | async)?.length === 0
      }"
   >
      <kendo-grid
         samwebPersistKendoGrid
         samwebVirtualScrollKendoGrid
         samwebKendoInfinityScrolling
         kendoTooltip
         showOn="none"
         [virtualScrollData]="directorySearchResult$ | async"
         [virtualScrollBufferTime]="renderBufferTime"
         [virtualScrollWasSearchExecuted]="!(wasSearchEverExecuted$ | async)"
         [tooltipTemplate]="tooltipTemplate"
         #cellTooltipDirective="kendoTooltip"
         filter=".k-grid td"
         (mouseover)="showTooltip($event)"
         (mouseout)="hideTooltip()"
         [infinityScrollRequestMoreData]="loadMoreDirectoryValuesFn()"
         [columnMenu]="true"
         [sortable]="
            !(isPhonetic$ | debounceTime: renderBufferTime | async)
               ? {
                    allowUnsort: false,
                    mode: 'single'
                 }
               : false
         "
         [sort]="sortDescription$ | debounceTime: renderBufferTime | async"
         (sortChange)="sortChange($event)"
         [resizable]="true"
         [reorderable]="true"
         fxFlex="1 1 *"
         (selectedKeysChange)="selectedKeysChange($event)"
         (cellClick)="kendoCellClick($event)"
         (cellDoubleClick)="kendoCellDoubleClick($event)"
         [selectable]="{
            mode: 'single'
         }"
         kendoGridSelectBy="id"
         [selectedKeys]="selectedKeys$ | async"
      >
         <kendo-grid-column
            *ngFor="let availableColumn of availableColumns$ | async"
            [field]="availableColumn.directoryColumnKey"
            [hidden]="!(availableColumn.columnTyp.isDefaultVisible && availableColumn.organisationUnitNumber === '00')"
            [title]="availableColumn | directoryColumnTitle | async"
            [sortable]="availableColumn.columnTyp.isValueSearchable && availableColumn.organisationUnitNumber === '00'"
         >
            <ng-template kendoGridHeaderTemplate *ngIf="availableColumn.columnTyp.isValueSearchable">
               <samweb-directory-table-header
                  class="grid-header"
                  [directoryColumnInstance]="availableColumn"
                  [isSearchable]="
                     availableColumn
                        | directoryColumnHeaderIsSearchable: (searchableColumns$ | debounceTime: renderBufferTime)
                        | async
                  "
                  [isDefaultCallColumn]="
                     availableColumn | directoryColumnHeaderIsCallable: defaultCallableColumn$ | async
                  "
                  (columnHeaderSearch)="columnHeaderSearchChanged(availableColumn, brickInstanceId)"
               >
               </samweb-directory-table-header>
            </ng-template>

            <ng-template kendoGridCellTemplate let-dataItem *samwebVar="callableColumns$ | async as callableColumns">
               <ng-container
                  *samwebVar="
                     availableDirectoryData$
                        | availableDirectoryDataForColumn: availableColumn
                        | availableDirectoryDataForEntry: dataItem.id
                        | async as cellValue
                  "
               >
                  <ng-container *ngIf="isPhonetic$ | async; else searchable_columns">
                     <ng-container *ngTemplateOutlet="no_searchable_column"> </ng-container>
                  </ng-container>
                  <ng-template #searchable_columns>
                     <ng-container
                        *ngIf="
                           availableColumn | directoryColumnIsSearchable$: brickInstanceId | async;
                           else no_searchable_column
                        "
                     >
                        <div
                           class="grid-cell"
                           [innerHTML]="cellValue | highlightText$: directorySearchHighlightRegExp$ | async"
                        ></div>
                     </ng-container>
                  </ng-template>
                  <ng-template #no_searchable_column>
                     <div class="grid-cell">{{ cellValue }}</div>
                  </ng-template>
               </ng-container>
            </ng-template>
         </kendo-grid-column>

         <kendo-grid-column
            field="presenceStatus"
            [title]="'brick.brick_definitions.directory_browser.columns.presence_status.title' | translate"
            [sortable]="false"
         >
            <ng-template kendoGridHeaderTemplate>
               <div class="sam-ellipsis-on-overflow">
                  {{ 'brick.brick_definitions.directory_browser.columns.presence_status.title' | translate }}
               </div>
            </ng-template>
            <ng-template kendoGridCellTemplate let-dataItem>
               <samweb-presence-status
                  [presenceId]="dataItem?.ocsId"
                  [presenceTypeValue]="dataItem?.presenceType?.value"
               ></samweb-presence-status>
            </ng-template>
         </kendo-grid-column>
         <kendo-grid-column
            field="mobileStatus"
            [title]="'brick.brick_definitions.directory_browser.columns.mobile_status.title' | translate"
            [sortable]="false"
         >
            <ng-template kendoGridHeaderTemplate>
               <div class="sam-ellipsis-on-overflow">
                  {{ 'brick.brick_definitions.directory_browser.columns.mobile_status.title' | translate }}
               </div>
            </ng-template>
            <ng-template kendoGridCellTemplate let-dataItem>
               <samweb-mobile-status [mobilePresenceId]="dataItem?.fldMobile"></samweb-mobile-status>
            </ng-template>
         </kendo-grid-column>
         <kendo-grid-column
            field="lineStatus"
            [title]="'brick.brick_definitions.directory_browser.columns.line_status.title' | translate"
            [sortable]="false"
         >
            <ng-template kendoGridHeaderTemplate>
               <div class="sam-ellipsis-on-overflow">
                  {{ 'brick.brick_definitions.directory_browser.columns.line_status.title' | translate }}
               </div>
            </ng-template>
            <ng-template kendoGridCellTemplate let-dataItem>
               <samweb-line-status [tr87Number]="dataItem?.tr87Number" [orgnum]="dataItem?.orgnum">
               </samweb-line-status>
            </ng-template>
         </kendo-grid-column>
         <kendo-grid-column
            field="presenceStatusNote"
            [title]="'brick.brick_definitions.directory_browser.columns.presence_status_note.title' | translate"
            [sortable]="false"
         >
            <ng-template kendoGridHeaderTemplate>
               <div class="sam-ellipsis-on-overflow">
                  {{ 'brick.brick_definitions.directory_browser.columns.presence_status_note.title' | translate }}
               </div>
            </ng-template>
            <ng-template kendoGridCellTemplate let-dataItem>
               <samweb-presence-status-note
                  [presenceId]="dataItem?.ocsId"
                  [presenceTypeValue]="dataItem?.presenceType?.value"
               ></samweb-presence-status-note>
            </ng-template>
         </kendo-grid-column>
         <kendo-grid-column
            field="presenceStatusForwardDestination"
            [title]="
               'brick.brick_definitions.directory_browser.columns.presence_status_forward_destination.title' | translate
            "
            [sortable]="false"
         >
            <ng-template kendoGridHeaderTemplate>
               <div class="sam-ellipsis-on-overflow">
                  {{
                     'brick.brick_definitions.directory_browser.columns.presence_status_forward_destination.title'
                        | translate
                  }}
               </div>
            </ng-template>
            <ng-template kendoGridCellTemplate let-dataItem>
               <samweb-presence-status-forward-destination
                  [presenceId]="dataItem?.ocsId"
                  [presenceTypeValue]="dataItem?.presenceType?.value"
               >
               </samweb-presence-status-forward-destination>
            </ng-template>
         </kendo-grid-column>

         <kendo-grid-column field="appointments" [title]="" [sortable]="false">
            <ng-template kendoGridHeaderTemplate>
               <div class="sam-ellipsis-on-overflow">
                  {{ 'brick.brick_definitions.directory_browser.columns.appointments.title' | translate }}
               </div>
            </ng-template>
            <ng-template kendoGridCellTemplate let-dataItem>
               <samweb-appointments [id]="dataItem?.id" [brickInstanceId]="brickInstanceId"></samweb-appointments>
            </ng-template>
         </kendo-grid-column>

         <ng-template kendoGridNoRecordsTemplate>
            <samweb-grid-wait-for-data
               [wasSearchingEverStarted$]="wasSearchEverExecuted$"
               [brickInstanceIdFroLongRunningCheck]="brickInstanceId"
               [disableInfinityScrollDuringLongRunningCategories]="['DIRECTORY_SEARCH']"
            ></samweb-grid-wait-for-data>
         </ng-template>
      </kendo-grid>
   </div>
   <!--  </samweb-infinity-scrolling>-->
</div>
